import { apiRequest } from './api';
import { PaginatedResponse } from '../store/evaluation/types';

export interface GetEvaluationsParams {
  page: number;
  limit: number;
  trigger_type?: string;
  trigger_id?: string;
}

export interface EmbeddingContext {
  id: string;
  embedding: string;
  context: string;
  source: string;
}

export const getEvaluations = async (params: GetEvaluationsParams): Promise<PaginatedResponse> => {
  const queryParams: Record<string, string> = {};

  if (params.page) queryParams.page = params.page.toString();
  if (params.limit) queryParams.limit = params.limit.toString();
  if (params.trigger_type) queryParams.trigger_type = params.trigger_type;
  if (params.trigger_id) queryParams.trigger_id = params.trigger_id;

  return apiRequest<PaginatedResponse>('/admin/evals', { params: queryParams });
};

export const getEvaluationContext = async (evaluationId: string): Promise<EmbeddingContext[]> => {
  return apiRequest<EmbeddingContext[]>(`/admin/evals/${evaluationId}/context`);
};

interface CritiqueData {
  human_scores: number;
  critique: string;
}

export const saveCritique = async (evaluationId: string, data: CritiqueData): Promise<void> => {
  return apiRequest<void>(`/admin/evals/${evaluationId}/critique`, {
    method: 'PUT',
    data,
  });
};
